var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageProfile21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A56EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47856 9.832V16.744C8.47856 17.8107 8.6759 18.6213 9.07056 19.176C9.46523 19.72 10.1586 19.992 11.1506 19.992C12.1426 19.992 12.8359 19.72 13.2306 19.176C13.6252 18.6213 13.8226 17.8107 13.8226 16.744V9.832H15.1666V16.424C15.1666 17.2347 15.0919 17.9387 14.9426 18.536C14.8039 19.1333 14.5746 19.6293 14.2546 20.024C13.9346 20.4187 13.5132 20.712 12.9906 20.904C12.4786 21.096 11.8492 21.192 11.1026 21.192C10.3559 21.192 9.72656 21.096 9.21456 20.904C8.71323 20.712 8.3079 20.4187 7.99856 20.024C7.68923 19.6293 7.46523 19.1333 7.32656 18.536C7.19856 17.9387 7.13456 17.2347 7.13456 16.424V9.832H8.47856ZM18.0583 21V9.832H22.5063C23.509 9.832 24.277 10.12 24.8103 10.696C25.3543 11.2613 25.6263 12.04 25.6263 13.032C25.6263 14.024 25.3543 14.808 24.8103 15.384C24.277 15.9493 23.509 16.232 22.5063 16.232H19.4023V21H18.0583ZM19.4023 15.048H22.5063C23.0396 15.048 23.4503 14.9093 23.7383 14.632C24.037 14.3547 24.1863 13.96 24.1863 13.448V12.616C24.1863 12.104 24.037 11.7093 23.7383 11.432C23.4503 11.1547 23.0396 11.016 22.5063 11.016H19.4023V15.048Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageProfile21);
export default __webpack_public_path__ + "static/media/Image_Profile_2-1.0f95670a57feb5db403ff6793293c962.svg";
export { ForwardRef as ReactComponent };